import React from 'react';
import { motion } from 'framer-motion';
import { HUMANS, scenarios } from '../../data/populations';
import { useScenario } from '../../contexts/ScenarioContext';
import { formatRatio } from '../../utils/format';
import { SourceRef } from '../SourceRef';
const TICKS = [0.001, 0.01, 0.1, 1, 10];
const toPct = (r: number) => Math.min(100, Math.max(0, (Math.log10(r) + 3) / 4 * 100));
export function RatioGauge() {
  const {
    scenario
  } = useScenario();
  const ratio = scenario.count / HUMANS.base;
  const lowPct = toPct(scenario.low / HUMANS.base);
  const highPct = toPct(scenario.high / HUMANS.base);
  return <section aria-labelledby="gauge-title" className="pt-10" data-id="element-85" data-mp="1hb93ytcrfa8v">
      <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-86" data-mp="1cbmoed9glhww">
        <div data-id="element-87" data-mp="1cdh9pson7c1i">
          <h2 id="gauge-title" className="font-mono text-[11px] uppercase tracking-[0.16em] text-muted" data-id="element-88" data-mp="2spmlzhku0vgz">
            Agents per human
          </h2>
          <p className="mt-2 font-mono text-4xl tabular text-machine md:text-5xl" data-id="element-89" data-mp="2npqkbozlxg4l">
            {formatRatio(ratio)} <span className="text-muted" data-id="element-90" data-mp="s6jmrhtjrgaa">: 1</span>
            <SourceRef id="fermi" estimate={{
            low: formatRatio(scenario.low / HUMANS.base),
            high: formatRatio(scenario.high / HUMANS.base)
          }} data-id="element-91" data-mp="w8elqfo09hkw" />
          </p>
        </div>
        <p className="max-w-xs text-right text-[13px] leading-snug text-muted" data-id="element-92" data-mp="115ok4ktdh3kv">
          Parity projected 2026–2027 (base case)
          <SourceRef id="fermi" estimate={{
          low: '2026',
          high: '2028'
        }} data-id="element-93" data-mp="8jdn1k4z5kst" />
        </p>
      </div>

      <div className="relative mt-8 pb-8" role="img" aria-label={`Log scale gauge. Current scenario ${formatRatio(ratio)} agents per human; parity at 1.0.`} data-id="element-94" data-mp="dhx8ljfnoukn">
        <div className="relative h-3 rounded-full bg-raised" data-id="element-95" data-mp="ifyq3zxfolu0">
          <div className="absolute inset-y-0 rounded-full border border-machine/40 bg-machine/10" style={{
          left: `${lowPct}%`,
          width: `${Math.max(0.6, highPct - lowPct)}%`
        }} data-id="element-96" data-mp="n89ouzgfu1kz" />
          <motion.div className="absolute inset-y-0 left-0 rounded-full bg-machine" initial={false} animate={{
          width: `${toPct(ratio)}%`
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-97" data-mp="3qwtlyvftd5yl" />
          {scenarios.filter(s => s.id !== scenario.id).map(s => <span key={s.id} className="absolute top-1/2 h-2 w-px -translate-y-1/2 bg-ink/40" style={{
          left: `${toPct(s.count / HUMANS.base)}%`
        }} aria-hidden="true" data-id="element-98" data-mp="3slf5tu3iysjq" />)}
        </div>
        <div className="absolute -top-3 bottom-4 w-px bg-human" style={{
        left: `${toPct(1)}%`
      }} aria-hidden="true" data-id="element-99" data-mp="2zxt4ytlom20k">
          <span className="absolute -top-5 left-1/2 -translate-x-1/2 whitespace-nowrap font-mono text-[11px] text-human" data-id="element-100" data-mp="2vy0q5z5p2zmr">parity = 1.0</span>
        </div>
        <div className="absolute inset-x-0 bottom-0 flex justify-between font-mono text-[10.5px] text-muted" aria-hidden="true" data-id="element-101" data-mp="34vkvbj6ohg2n">
          {TICKS.map(t => <span key={t} className="tabular" data-id="element-102" data-mp="k6dmguifvmv2">
              {t}
            </span>)}
        </div>
      </div>
    </section>;
}